import {
  UPDATE_SPEAKERS_FILES,
  SPEAKER_FILES_CHANGED,
  WORKING_DYNAMIC_FORM,
  FETCH_ALL_PRODUCT_CATEGORY,
  FETCH_ALL_PRODUCT_SUB_CATEGORY,
  FETCH_ALL_INDUSTRY
} from '../actions';
var defaultSpeakerAttachment = [
  { position: 'file1', file: '', filename: '' },
  { position: 'file2', file: '', filename: '' },
  { position: 'file3', file: '', filename: '' },
  { position: 'file4', file: '', filename: '' },
  { position: 'file5', file: '', filename: '' }
];

export const speakerAttachments = (
  state = defaultSpeakerAttachment,
  action
) => {
  if (action.type === UPDATE_SPEAKERS_FILES) {
    return action.payload;
  }
  return state;
};

export const speakerAttachmentsChanged = (state = false, action) => {
  if (action.type === SPEAKER_FILES_CHANGED) {
    return action.payload;
  }
  return state;
};

export const workingDynamicForm = (state = [], action) => {
  if (action.type === WORKING_DYNAMIC_FORM) {
    return action.payload;
  }
  return state;
};

export const productCategories = (state = {}, action) => {
  switch (action.type) {
    case FETCH_ALL_PRODUCT_CATEGORY:
      return action.payload;
    default:
      return state;
  }
};

export const productSubCategories = (state = {}, action) => {
  switch (action.type) {
    case FETCH_ALL_PRODUCT_SUB_CATEGORY:
      return action.payload;
    default:
      return state;
  }
};

export const masterIndustriesReducer = (state = {}, action) => {
  if (action.type === FETCH_ALL_INDUSTRY) return action.payload;
  return state;
};
